import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Card, Alert, InputGroup } from 'react-bootstrap';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast, isNative } from '../context/MenuProvider';


const ConectarWhatsApp = () => {
  const [qrCode, setQrCode] = useState(null);

  const {
    crud,
    setTitle,
    auth,
  } = useProvider();
  const { post, get } = crud || {};

  useEffect(() => {
    const intervalRef = { current: null };

    const carregarStatusAtual =()=> {
        // ✅ FLUXO PWA
        if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage("atualizar-auth");
        } 
        // ✅ FLUXO NATIVO (APK)
        else {
            // No nativo, enviamos para a própria window pois o service-worker.js
            // foi carregado como um script comum que ouve a window.
            window.dispatchNativeMessage("atualizar-auth");
        }
    }

    const conectarWhatsApp = async (tentativa = 0) => {
      try {
        const response = await get(`/core/mensagens-whatsapp/conectar/`);
        //alert(JSON.stringify(response))
        if (response && response.length) {
          const wp = response[0];
          const statusAtual = wp.status;
          setQrCode(wp);

          // Para o loop se o status retornado for 'conectado'
          if (statusAtual === 'conectado') {
            Toast.fire({
              icon: 'success',
              title: `WhatsApp ${wp.numero} conectado`
            });

            clearInterval(intervalRef.current);
            carregarStatusAtual();
          }
        }
      } catch (err) {
        //alert(JSON.stringify(err?.response || err))
        if (tentativa < 5) {
          conectarWhatsApp(tentativa + 1);
        } 
      }
    };

    setTitle("Conexão WhatsApp");

    // Só inicia o loop se o estado inicial não for 'conectado'
    if (qrCode?.status !== 'conectado') {
      conectarWhatsApp();

      intervalRef.current = setInterval(() => {
        conectarWhatsApp();
      }, 20000);
    }

    //Carregar o status atual quanto tiver mudança de status
    carregarStatusAtual();

    // Limpa o loop ao fechar a tela ou se o status mudar para 'conectado'
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [qrCode?.status]);


  return (<>
    <Row>
      <Col md={6} lg={4} className="mx-auto">
        {qrCode?.qr && (
          <div className="d-flex justify-content-center">
            <img src={qrCode?.qr} className="img-fluid" />
          </div>
        )}
        <div className="fs-4 text-center">
          <div>{qrCode?.numero || auth?.empresa?.telefone_whatsapp}</div>
          <div>
            {!qrCode && (<>
              {auth?.empresa?.whatsapp_conectado?"Conectado":"Desconectado"}
            </>)}
            {qrCode?.status === "conectado" && (<>
              Conectado
            </>)}
            {qrCode?.status === "aguardando_qr" && (<>
              Escaneie o QR Code para conectar
            </>)}
            {qrCode?.status === "desconectado" && (<>
              Desconectado
            </>)}
          </div>
          {!qrCode && (<div className="pt-4">Aguarde ...</div>)}
        </div>
      </Col>
      <Col xs={12}>
        {qrCode?.status === "aguardando_qr" && (
          <div className="text-center">
            <p><strong>Atenção:</strong> Você precisa de dois dispositivos para conectar. Como o WhatsApp usa a câmera do celular, não é possível escanear o QR Code se ele estiver na tela do próprio aparelho que você está usando.</p>
            <p>Para prosseguir, abra o link <strong>https://gvendas.app.br</strong> em um computador ou outro celular e siga os passos abaixo no seu aparelho principal:</p>
            
            <p><strong>Para Android:</strong> Abra o WhatsApp, toque nos três pontos no canto superior direito e vá em <em>Aparelhos conectados &gt; Conectar um dispositivo</em> para escanear o código.</p>
            
            <p><strong>Para iOS (iPhone):</strong> Abra o WhatsApp, vá em <em>Configurações &gt; Aparelhos conectados &gt; Conectar um dispositivo</em> e escaneie o código.</p>
            
            <p>Mantenha esta tela aberta até que o status mude para <strong>conectado</strong>.</p>
          </div>
        )}
      </Col>
    </Row>
  </>
  );
};

export default ConectarWhatsApp;